import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';



// Data Loading component

const DataLoading = ({ title }) => {

    const { t } = useTranslation();

    return <div className="page page-center" >
        <div className="container container-tight py-4">
            <div className="text-center">
                <div className="mb-3">
                    <a href="." className="navbar-brand navbar-brand-autodark"></a>
                </div>
                <div className="text-secondary mb-3">{title ?? t('loadingRequestedData')}</div>
                <div className="progress progress-sm">
                    <div className="progress-bar progress-bar-indeterminate"></div>
                </div>
            </div>
        </div>
    </div>
}

export default DataLoading;

DataLoading.propTypes = {
    title: PropTypes.string
}






// const Loader = ({ title }) => {


//     const { t } = useTranslation();

//     return <div id="loader-dv" >
//         <div className="container container-tight py-4">
//             <div className="text-center">
//                 <div className="mb-3">
//                     <a href="." className="navbar-brand navbar-brand-autodark"></a>
//                 </div>
//                 <div className="text-secondary mb-3">{title ?? t('loadingRequestedData')}</div>
//                 <div className="progress progress-sm">
//                     <div className="progress-bar progress-bar-indeterminate"></div>
//                 </div>
//             </div>
//         </div>
//     </div>
// }
const Loader = ({ title }) => {

    const { t } = useTranslation();

    return <>

        {/* <div className='' style={{width:'100%',height:'100%',background:'#000',opacity:0.6 ,position:'relative'}}></div> */}
        <div id="loader-dv" >
            <div className="container container-tight py-4 " style={{ background: '#fff' }}>
                <div className="text-center " >
                    <div className="mb-3">
                        <a href="." className="navbar-brand navbar-brand-autodark"></a>
                    </div>
                    <div className="text-secondary mb-3">{title ?? t('loadingRequestedData')}</div>
                    <div className="progress progress-sm mb-2">
                        <div className="progress-bar progress-bar-indeterminate"></div>
                    </div>
                </div>
            </div>
        </div>
    </>
}

export { Loader }

Loader.propTypes = {
    title: PropTypes.string
}